import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class EntityService {
  entityFormValue: any;

  setFormValue(formData: any) {
    this.entityFormValue = formData;
  }
  getFormValue() {
    return this.entityFormValue;
  }
}
